const PriorAuthSteps = () => (
  <section>
    <div className="max-w-screen-xl px-4 py-12 pt-6 mx-auto sm:px-6 lg:px-8">
      <h1 className="text-lg font-semibold">Prior Authorizations</h1>
      <p>
        Learn about our prior authorization process and get helpful information
        to request coverage approval for your patients. Prior Authorization
        occurs before planned inpatient admissions and select healthcare
        services on the prior authorization requirements list below.
      </p>
      <p className="pt-4">Benefits of prior authorization: </p>
      <ul className="my-2 ml-6 list-disc">
        <li>
          to assure members health benefits are administered appropriately
        </li>
        <li>
          members receive treatments that are proven to be safe and effective
          for the condition being treated{' '}
        </li>
        <li>
          members and their appointed representatives will know coverage
          decisions before procedures, services or supplies are provided
        </li>
        <li>
          identification of members to pair them with specialty programs with
          case management and disease management
        </li>
      </ul>
      <p className="pt-2">
        The prior approval process is called prior authorization, or prior
        authorization (PA). Providers can submit prior authorization requests on
        behalf of their patients. The prior authorization process is part of the
        Utilization Review (UR) activities performed by Evry Health. Please
        note, prior authorizations through the Utilization Review process are
        not intended to provide medical advice or medical care. Medical advice
        and care should be discussed with treating providers.
      </p>
      <p className="pt-2">
        For information on the{' '}
        <span className="font-bold">
          prior authorization for pharmacy benefits
        </span>
        , see this website{' '}
        <a
          href="https://prime.adaptiverx.com/webSearch/index?key=cnhmbGV4LnBsYW4uUGxhblBkZlR5cGUtODA5"
          className="font-bold cursor-pointer text-green"
        >
          here
        </a>
      </p>
      <h1 className="pt-6 text-lg font-semibold">Screening Criteria</h1>
      <p>
        Reviews for determining medical necessity for inpatient and outpatient
        services are performed utilizing initial eligibility of benefits for
        coverage and the following resources or criteria may be used during the
        determination process for medical necessity review:
      </p>
      <ul className="my-2 ml-6 list-disc">
        <li>State and Federal Guidelines</li>
        <li>Proprietary Medical Policies</li>
        <li>MCG Guidelines</li>
        <li>American Society of Addiction Medicine Criteria (ASAM) Criteria</li>
        <li>
          Standards for Reasonable Cost Control and Utilization Review for
          Chemical Dependency Treatment Centers Texas Administrative Code
          (state.tx.us)
        </li>
      </ul>
      <p className="pt-2">
        Other information sources to help to determine medical necessary and
        benefits coverage may include: Up to Date® applicable to the clinical
        situation, National Comprehensive Cancer Network (NCCN) Guidelines,
        Reference to other Health Plan policies (comparing accepted standards).
      </p>
      <h1 className="pt-6 text-lg font-semibold">
        Prior Authorization Submission Process:
      </h1>
      <p className="pt-2">
        For authorization handled by Evry, providers may request authorization
        by the following process:{' '}
      </p>
      <p className="pt-2">
        Step 1: Complete the Texas Standard Prior Authorization Request Form*
        available for download at{' '}
        <a
          href="https://www.evryhealth.com/prior-authorization"
          className="font-bold cursor-pointer text-green"
        >
          https://www.evryhealth.com/prior-authorization.
        </a>
      </p>
      <p className="pt-2">
        Step 2: Once completed, please fax the completed prior authorization
        request form along with the required documentation listed below to
        request prior authorization. Completion of the form with supporting
        documentation is required to complete a medical necessity review.
      </p>
      <h1 className="pt-6 text-lg font-semibold">
        Documentation Requirements:
      </h1>
      <p className="pt-2">
        Essential elements necessary to be submitted with prior authorization
        requests include ALL of the following:
      </p>
      <p className="pt-2">A. Completed prior authorization request form</p>
      <p className="pt-2">
        B. Clinical Documentation supporting the requested services (including
        but not limited to):
      </p>
      <p className="pt-2 ml-4">
        i. Medical History (include treatment, diagnostic tests, examination
        data)
      </p>
      <p className="pt-2 ml-4">
        ii. Description of treatment plan and treatment to date
      </p>
      <p className="pt-2 ml-4">iii. Diagnostic/Laboratory/Radiology results</p>
      <p className="pt-2 ml-4">
        iv. Clinical notes necessary to certify medical necessity
      </p>
      <p className="pt-2">
        All determinations or requests for more information in order to make an
        initial UR determination are made in a timely fashion appropriate for
        the member’s specific condition, not to exceed the timeframes required
        by NCQA, Texas state, and/or federal regulations. Decisions are
        communicated both verbally and/or in writing to providers and members,
        as required by regulations. To verify member eligibility, benefits, or
        account information, the provider should contact the Plan utilizing the
        customer service telephone number(s) available on the member’s
        identification card and/or the Plan website{' '}
        <a className="font-bold text-green" href="https://www.evryhealth.com">
          www.evryhealth.com.
        </a>
      </p>

      <h1 className="pt-6 text-lg font-semibold">
        Prior Authorization Requirement List:
      </h1>

      <p className="pt-2">
        All Requirements are effective as of 06/01/2022. For a list of updated
        prior authorization requirements for medical services see{' '}
        <a href="./prior-auth-list-updates" className="font-bold text-green">
          prior authorization list updates for medical services
        </a>
        . Visit Prior Authorization ({' '}
        <a className="font-bold text-green" href="https://www.evryhealth.com">
          www.evryhealth.com.
        </a>
        ) for a list of services requiring authorization.
      </p>

      <p className="pt-2">
        prior authorization is required before the service is provided in
        non-emergent situations.{' '}
        <span className="underline">
          Retroactive requests will be denied unless there are extenuating
          circumstances
        </span>
        . All prior authorizations should be requested using Evry Health Plan’s
        request form. Supporting documentation (e.g., notes and lab or radiology
        findings) should be sent with all prior authorization requests.
      </p>

      <p className="pt-2">
        Prior Authorization Form: www.evryhealth.com | Phone: 1(855)579-3879 |
        Medical Fax: 1(325)603-0541
      </p>

      <p className="pt-2 pb-6">
        Please call to check the status of an existing authorization or inquire
        if a procedure or healthcare service requires prior authorization.
      </p>

      {/* <a
        href="#preAuthTool"
        className="font-bold text-green hover:underline animate-pulse"
      >
        Go to the Pre-Auth Tool
      </a> */}
    </div>
  </section>
)

export default PriorAuthSteps
